import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationsMosaic, { Props as MosaicProps } from '../DeviationsMosaic';
import StandardThumb from '../DeviationViews/Thumb/Standard';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

import s from './MeasuredDeviationsMosaic.scss';

interface Props {
  deviations: PapiDeviation[];
  height?: number;
  cookieType?: MeasuredCookieType;
  deviationView?: React.ComponentType<any>;
}

const defaultPadding = parseInt(s['padding']);

const MeasuredDeviationsMosaic: React.FC<Props & Omit<MosaicProps, 'width' | 'height'>> = ({
  deviations,
  contentClassName,
  className,
  cookieType = MeasuredCookieType.BROWSE,
  height = 375,
  padding = defaultPadding,
  deviationView = StandardThumb,
}) => {
  const { ref, dimensions } = useMeasureElementCookie(cookieType, {
    cookieDim: 'width',
  });

  return (
    <div ref={ref}>
      <DeviationsMosaic
        width={dimensions.width}
        height={height}
        deviations={deviations}
        contentClassName={classnames(contentClassName, s['default-padding'])}
        className={className}
        padding={padding}
        deviationView={deviationView}
      />
    </div>
  );
};
MeasuredDeviationsMosaic.displayName = 'MeasuredDeviationsMosaic';

export default MeasuredDeviationsMosaic;
